import { render, staticRenderFns } from "./AttorneyInsuredSelect.vue?vue&type=template&id=10efa3fa&scoped=true&"
import script from "./AttorneyInsuredSelect.vue?vue&type=script&lang=js&"
export * from "./AttorneyInsuredSelect.vue?vue&type=script&lang=js&"
import style0 from "./AttorneyInsuredSelect.vue?vue&type=style&index=0&id=10efa3fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10efa3fa",
  null
  
)

export default component.exports